import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import { getServicesUrl, V20, V21, V11 } from '../../setup';
import Service from './service';
import { getQueryStringByObject } from '../../utils/queryUtils';

var ContactManagement =
/*#__PURE__*/
function (_Service) {
  _inherits(ContactManagement, _Service);

  function ContactManagement() {
    _classCallCheck(this, ContactManagement);

    return _possibleConstructorReturn(this, _getPrototypeOf(ContactManagement).apply(this, arguments));
  }

  _createClass(ContactManagement, null, [{
    key: "getClientProfile",
    value: function getClientProfile(contactId) {
      var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
      return Service.getRequest("".concat(getServicesUrl(V21), "/contacts/").concat(contactId, "/profile/").concat(language), {
        isSecure: true
      });
    }
  }, {
    key: "getClientPicture",
    value: function getClientPicture(contactId) {
      return Service.getRequest("".concat(getServicesUrl(), "/contacts/").concat(contactId, "/profilepicture"), {
        isSecure: true
      });
    }
  }, {
    key: "getMembersProfile",
    value: function getMembersProfile(internalUserId) {
      return Service.getRequest("".concat(getServicesUrl(), "/members/").concat(internalUserId, "/profile/"), {
        isSecure: true
      });
    }
  }, {
    key: "getPublicMemberProfile",
    value: function getPublicMemberProfile(internalUserId) {
      return Service.getRequest("".concat(getServicesUrl(), "/members/").concat(internalUserId, "/publicprofile/"), {
        isSecure: true
      });
    }
  }, {
    key: "getPublicMemberProfileIS",
    value: function getPublicMemberProfileIS(internalUserId) {
      return Service.getRequest("".concat(getServicesUrl(V20), "/members/").concat(internalUserId, "/publicprofile/"), {
        isSecure: true
      });
    }
  }, {
    key: "getContactMembers",
    value: function getContactMembers(contactId) {
      return Service.getRequest("".concat(getServicesUrl(), "/contacts/").concat(contactId, "/memberprofiles/"), {
        isSecure: true
      });
    }
  }, {
    key: "getOnBoardingData",
    value: function getOnBoardingData(contactId, language) {
      return Service.getRequest("".concat(getServicesUrl(V11), "/contacts/").concat(contactId, "/private/").concat(language), {
        isSecure: true
      });
    }
  }, {
    key: "getOnBoardingLanguageData",
    value: function getOnBoardingLanguageData() {
      return Service.getRequest("".concat(getServicesUrl(), "/countries/10"), {
        isSecure: true
      });
    }
  }, {
    key: "postOnBoardingData",
    value: function postOnBoardingData(data, contactId) {
      return Service.putRequest("".concat(getServicesUrl(), "/contacts/").concat(contactId, "/private"), {
        Gender: data.Gender,
        FirstName: data.FirstName,
        LastName: data.LastName,
        Street: data.Street,
        StreetNumber: data.StreetNumber,
        PostalCode: data.PostalCode,
        City: data.City,
        Country: data.Country,
        NationalityId: data.NationalityId,
        PreferredLanguageCultureCode: data.PreferredLanguageCultureCode,
        BirthDate: data.BirthDate,
        MobileNumber: data.MobileNumber,
        PhoneNumber: data.PhoneNumber
      }, {
        isSecure: true
      });
    }
  }, {
    key: "getContactsByFilter",
    value: function getContactsByFilter(memberId, filter) {
      return Service.postRequest("".concat(getServicesUrl(), "/members/").concat(memberId, "/hierarchy/contacts/filter"), _objectSpread({}, filter), {
        isSecure: true
      });
    }
  }, {
    key: "getContactsCount",
    value: function getContactsCount(memberId, params) {
      var queryString = getQueryStringByObject(_objectSpread({
        'aumRequest.memberId': memberId
      }, params));
      return Service.getRequest("".concat(getServicesUrl(), "/members/").concat(memberId, "/contactscount?").concat(queryString), {
        isSecure: true
      });
    }
  }]);

  return ContactManagement;
}(Service);

export default ContactManagement;